var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-item',{attrs:{"expanded":_vm.expanded,"link":"/assessment","icon":"mdi-tooltip-check","text":_vm.$t('assessment.nav')}}),_c('help',{attrs:{"expanded":_vm.expanded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }